import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { en, es, pt } from '../translations'


const initI18n = async () => {
  await i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
      fallbackLng: 'en',
      detection: {
        order: ['navigator', 'querystring' , 'cookie' ,'sessionStorage' ,'localStorage', 'htmlTag']
      },
      resources: {
        en: {
          translation: en
        },
        es: {
          translation: es
        },
        pt: {
          translation: pt
        }
      }
    })
}

export default initI18n
